import { render, staticRenderFns } from "./CompanyInfo_Categories.vue?vue&type=template&id=12f5b664&scoped=true"
import script from "./CompanyInfo_Categories.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_Categories.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_Categories.vue?vue&type=style&index=0&id=12f5b664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5b664",
  null
  
)

export default component.exports